import APIClient from '../lib/APIClient';
import { resolve } from '../helpers/LinkMapper';
import CallingPoints from '../records/CallingPoints';


const CallingPointsService = {

    async get (id) {
        const response = await APIClient.get(id);
        return resolve(response.result).as(CallingPoints);
    }

};


export default CallingPointsService;
